export const menu = {
  starters: [
    { id: 1, name: "Truffle Arancini", price: 18, desc: "Wild mushroom risotto, mozzarella, black truffle aioli.", tags: ["V"] },
    { id: 2, name: "Wagyu Carpaccio", price: 24, desc: "Parmesan crisp, capers, truffle oil, micro herbs.", tags: ["GF"] },
    { id: 3, name: "Burrata & Fig", price: 21, desc: "Heirloom tomato, balsamic glaze, basil pesto, sourdough.", tags: ["V"] }
  ],
  mains: [
    { id: 4, name: "Pan-Seared Scallops", price: 34, desc: "Cauliflower purée, pancetta crisp, lemon butter sauce.", tags: ["GF"] },
    { id: 5, name: "Herb Crusted Lamb Rack", price: 42, desc: "Fondant potato, seasonal greens, red wine jus.", tags: ["GF"] },
    { id: 6, name: "Wild Mushroom Risotto", price: 28, desc: "Porcini dust, parmesan crisp, truffle oil.", tags: ["V", "GF"] }
  ],
  desserts: [
    { id: 7, name: "Dark Chocolate Fondant", price: 16, desc: "Salted caramel center, vanilla bean ice cream.", tags: ["V"] },
    { id: 8, name: "Lemon Basil Tart", price: 15, desc: "Italian meringue, raspberry coulis.", tags: ["V"] }
  ]
};
